import captains from "./captains.component";
import captainsUrls from "./captains.urls";
import CaptainsTransforms from "./captains.transforms";

const captainsModule = angular
  .module("app.components.captains", [])
  .component("captainsPage", captains)
  .service("CaptainsTransforms", CaptainsTransforms)
  .config(captainsUrls);

export default captainsModule;



// WEBPACK FOOTER //
// ./src/pages/captains/captains.module.js